import { createReducer, createFeature, on } from "@ngrx/store";

import { methodTypeAdapter } from "./method-type.state";
import { methodTypeActions } from "./method-type.actions";

const initialState = methodTypeAdapter.getInitialState({
  loading: false,
  error: null,
});

const reducer = createReducer(
  initialState,
  on(methodTypeActions.findForSample, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(methodTypeActions.findForSampleSuccess, (state, { methodType }) => {
    return methodTypeAdapter.upsertOne(methodType, { ...state, loading: false, error: null });
  }),
  on(methodTypeActions.findForSampleFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
);

export const methodTypeFeature = createFeature({
  name: "protocolMethodTypes",
  reducer,
});